import { Icon, Input, Stack } from "@mui/material"
import { SearchSm } from "@untitled-ui/icons-react"

export default function SearchPool({
  handleChange,
}: {
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        position: "relative",
        zIndex: 1,
      }}
    >
      <Input
        type="text"
        sx={(theme) => ({
          background: theme.palette.titleBar,
          padding: "0.5rem 1rem",
          border: "1px solid",
          borderColor: theme.palette.titleBarBorder,
          borderRadius: 1,
          width: "100%",
        })}
        onChange={(e) => handleChange(e)}
        disableUnderline={true}
        placeholder="Search for Pool..."
      />
      <Icon
        sx={{
          position: "absolute",
          top: "50%",
          right: "6px",
          zIndex: 2,
          transform: "translateY(-50%)",
        }}
      >
        <SearchSm />
      </Icon>
    </Stack>
  )
}
